/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayWidth: NonNullable<unknown>, displayHeight: NonNullable<unknown> }} Position_Modal_Description_RangesInputs */

const en_position_modal_description_ranges = /** @type {(inputs: Position_Modal_Description_RangesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`events. Character position ranges from 1 to ${i?.displayWidth}, line position ranges from 1 to ${i?.displayHeight}.`)
};

const fr_position_modal_description_ranges = /** @type {(inputs: Position_Modal_Description_RangesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`evenements. La position des caracteres va de 1 a ${i?.displayWidth}, la position des lignes va de 1 a ${i?.displayHeight}.`)
};

const de_position_modal_description_ranges = /** @type {(inputs: Position_Modal_Description_RangesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ereignisse. Die Zeichenposition reicht von 1 bis ${i?.displayWidth}, die Zeilenposition von 1 bis ${i?.displayHeight}.`)
};

const it_position_modal_description_ranges = /** @type {(inputs: Position_Modal_Description_RangesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`eventi. La posizione del carattere varia da 1 a ${i?.displayWidth}, la posizione della riga varia da 1 a ${i?.displayHeight}.`)
};

const ru_position_modal_description_ranges = /** @type {(inputs: Position_Modal_Description_RangesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`События. Позиция символа варьируется от 1 до ${i?.displayWidth}, позиция строки варьируется от 1 до ${i?.displayHeight}.`)
};

const es_position_modal_description_ranges = /** @type {(inputs: Position_Modal_Description_RangesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`eventos. La posición del carácter varía de 1 a ${i?.displayWidth}, la posición de la línea varía de 1 a ${i?.displayHeight}.`)
};

const zh_cn2_position_modal_description_ranges = /** @type {(inputs: Position_Modal_Description_RangesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件。字符位置范围为 1 到 ${i?.displayWidth}，行位置范围为 1 到 ${i?.displayHeight}。`)
};

const ja_position_modal_description_ranges = /** @type {(inputs: Position_Modal_Description_RangesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント。文字位置は 1 から ${i?.displayWidth} まで、行位置は 1 から ${i?.displayHeight} までの範囲です。`)
};

const hi_position_modal_description_ranges = /** @type {(inputs: Position_Modal_Description_RangesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`घटनाएँ। वर्ण की स्थिति 1 से ${i?.displayWidth} तक होती है, पंक्ति की स्थिति 1 से ${i?.displayHeight} तक होती है।`)
};

const pt_pt2_position_modal_description_ranges = /** @type {(inputs: Position_Modal_Description_RangesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`eventos. A posição do caractere varia de 1 a ${i?.displayWidth}, a posição da linha varia de 1 a ${i?.displayHeight}.`)
};

/**
* | output |
* | --- |
* | "events. Character position ranges from 1 to {displayWidth}, line position ranges from 1 to {displayHeight}." |
*
* @param {Position_Modal_Description_RangesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_description_ranges = /** @type {((inputs: Position_Modal_Description_RangesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Description_RangesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_modal_description_ranges(inputs)
	if (locale === "de") return de_position_modal_description_ranges(inputs)
	if (locale === "it") return it_position_modal_description_ranges(inputs)
	if (locale === "ru") return ru_position_modal_description_ranges(inputs)
	if (locale === "es") return es_position_modal_description_ranges(inputs)
	if (locale === "zh-CN") return zh_cn2_position_modal_description_ranges(inputs)
	if (locale === "ja") return ja_position_modal_description_ranges(inputs)
	if (locale === "hi") return hi_position_modal_description_ranges(inputs)
	if (locale === "pt-PT") return pt_pt2_position_modal_description_ranges(inputs)
	return en_position_modal_description_ranges(inputs)
});